export default "__VITE_ASSET__CwC97jWy__"